import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    box: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "80px",
        [theme.breakpoints.down("desktop")]: {
            display: "block",
            marginTop: "0px",
        },
    },

    container: {
        display: "flex",
        direction: "ltr",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start",
        position: "relative",
        padding: "70px 30px",
        height: "70vh",
        fontWeight: "normal",
        letterSpacing: "0",
        lineHeight: "24px",
        borderRadius: "13px",
        backgroundColor: theme.colors.white,
        boxShadow: "0 5px 14px 0 rgba(0,0,0,0.2)",
        [theme.breakpoints.down("desktop")]: {
            height: "auto",
            padding: 0,
            boxShadow: "none",
            paddingTop: 30,
        },
    },

    textContainer: {
        overflowY: "scroll",
        [theme.breakpoints.down("desktop")]: {
            overflowY: "visible",
        },
    },
    close: {
        position: "absolute",
        top: "28px",
        right: "28px",
        cursor: "pointer",
        fontSize: "28px",
        [theme.breakpoints.down("desktop")]: {
            top: 0,
            right: 0,
        },
    },
    descriptionContainer: {
        marginTop: 24,
        [theme.breakpoints.down("desktop")]: {
            marginTop: 16,
        },
    },
}));

export default useStyles;
